module.exports = require("/tmp/build_313648bf/src/lib/gatsby/gatsby-browser.tsx");